import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'colli/history/',
    pluginName: 'LOGISTIC',
    entityName: 'COLLI_HISTORY',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false
});

// Fetch ColliHistory action creators
export const fetchColliHistoryInit = () => {
    return crudActions.fetchInit();
};
export const fetchColliHistoryStart = () => {
    return crudActions.fetchStart();
};
export const fetchColliHistorySuccess = (fetchColliHistoryCount, listColliHistoryCount) => {
    return crudActions.fetchSuccess(fetchColliHistoryCount, listColliHistoryCount);
};
export const fetchColliHistoryFail = () => {
    return crudActions.fetchFail();
};

export const fetchColliHistoryCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchColliHistoryStart());
        try {
            let countRes = await rest.post("colli/history/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchColliHistorySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchColliHistoryFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch colli history."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchColliHistoryFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch colli history."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchColliHistory = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchColliHistoryStart());
        try {
            let listRes = await rest.post("colli/history/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchColliHistorySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchColliHistoryFail());
            return []

        } catch (error) {
            dispatch(fetchColliHistoryFail());
            return []

        }
    }
}
